import React, { createContext, useContext } from 'react';

interface NetworkQualityState {
  status: 'green' | 'orange' | 'red';
  speeds: { downloadMbps: number; uploadMbps: number };
  exitCountdownSec: number | null;
  hasUserRetried: boolean;
  isTesting: boolean;
  testProgress: number;
  sustainedRed: boolean;
}

interface NetworkQualityContextType {
  state: NetworkQualityState;
  manualRetry: () => Promise<void>;
  setBusy: (busy: boolean) => void;
}

const defaultState: NetworkQualityState = {
  status: 'green',
  speeds: { downloadMbps: 10, uploadMbps: 5 },
  exitCountdownSec: null,
  hasUserRetried: false,
  isTesting: false,
  testProgress: 0,
  sustainedRed: false,
};

const NetworkQualityContext = createContext<NetworkQualityContextType>({
  state: defaultState,
  manualRetry: async () => {},
  setBusy: () => {},
});

export const useNetworkQuality = () => useContext(NetworkQualityContext);

export const NetworkQualityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <NetworkQualityContext.Provider value={{ state: defaultState, manualRetry: async () => {}, setBusy: () => {} }}>
      {children}
    </NetworkQualityContext.Provider>
  );
};
